var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_703_257516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.087 26.0984V32.5298C96.087 33.5247 94.0423 34.3308 91.5183 34.3308C88.9965 34.3308 86.9497 33.5247 86.9497 32.5298V26.0984C86.9497 16.878 79.449 9.37949 70.2307 9.37949C61.0124 9.37949 53.5118 16.878 53.5118 26.0984V49.3321C53.5118 50.327 51.465 51.1331 48.9432 51.1331C46.4192 51.1331 44.3745 50.327 44.3745 49.3321V26.0984C44.3747 11.8403 55.9729 0.242188 70.2307 0.242188C84.4886 0.242188 96.087 11.8403 96.087 26.0984Z",
    fill: "url(#paint0_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2307 0.242188C69.8622 0.242188 69.4959 0.251855 69.1311 0.267109V9.41945C69.4971 9.39405 69.8638 9.38065 70.2307 9.37928C79.449 9.37928 86.9496 16.8778 86.9496 26.0982V32.5296C86.9496 33.5245 88.9964 34.3306 91.5183 34.3306C94.0422 34.3306 96.0869 33.5245 96.0869 32.5296V26.0982C96.0869 11.8403 84.4888 0.242188 70.2307 0.242188Z",
    fill: "url(#paint1_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9432 51.1327C51.465 51.1327 53.5118 50.3266 53.5118 49.3316V26.098C53.5118 25.3669 53.5641 24.648 53.6556 23.9414H44.4654C44.4054 24.6587 44.3752 25.3782 44.3748 26.098V49.3316C44.3748 50.3266 46.4194 51.1327 48.9432 51.1327Z",
    fill: "url(#paint2_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9499 26.098V32.5294C86.9499 33.5243 88.9967 34.3304 91.5186 34.3304C94.0426 34.3304 96.0872 33.5243 96.0872 32.5294V26.098C96.0872 25.3716 96.0556 24.6528 95.9966 23.9414H86.8064C86.8975 24.648 86.9499 25.3667 86.9499 26.098Z",
    fill: "url(#paint3_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.326 107.359C80.3036 111.202 60.1577 111.202 40.1356 107.359C37.6526 106.882 35.6462 104.705 35.0004 101.822C31.1321 84.5579 31.1319 67.1998 35.0004 49.9348C35.6464 47.052 37.6526 44.8746 40.1356 44.398C60.1577 40.5547 80.3036 40.5549 100.326 44.398C102.809 44.8746 104.815 47.052 105.461 49.9348C109.329 67.1998 109.329 84.5579 105.461 101.822C104.815 104.705 102.809 106.882 100.326 107.359Z",
    fill: "url(#paint4_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7832 77.6055H32.1127C32.2326 85.686 33.1948 93.7652 35.0004 101.824C35.6462 104.707 37.6526 106.884 40.1356 107.36C49.3333 109.126 58.5571 110.078 67.7832 110.222V77.6055Z",
    fill: "url(#paint5_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7832 77.6055H32.1127C32.2326 85.686 33.1948 93.7652 35.0004 101.824C35.6462 104.707 37.6526 106.884 40.1356 107.36C49.3333 109.126 58.5571 110.078 67.7832 110.222V77.6055Z",
    fill: "url(#paint6_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.461 49.9347C104.815 47.0517 102.809 44.8745 100.326 44.3979C88.4274 42.1139 76.4851 41.1875 64.5511 41.6181C72.6991 41.912 80.8434 42.8386 88.9673 44.3979C91.4502 44.8745 93.4567 47.0519 94.1025 49.9347C97.971 67.1997 97.9707 84.5578 94.1025 101.822C93.4564 104.705 91.4502 106.882 88.9673 107.359C80.8436 108.918 72.6995 109.844 64.5516 110.139C76.4855 110.569 88.4274 109.643 100.326 107.359C102.809 106.882 104.815 104.705 105.461 101.822C109.329 84.5578 109.33 67.1997 105.461 49.9347Z",
    fill: "url(#paint7_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.326 44.3965C96.1344 43.5923 91.9128 42.9544 87.6709 42.4844V44.1541C88.1029 44.2334 88.535 44.3138 88.967 44.3967C91.45 44.8732 93.4564 47.0507 94.1022 49.9334C97.9707 67.1985 97.9705 84.5566 94.1022 101.821C93.4562 104.704 91.45 106.881 88.967 107.358C88.535 107.44 88.1029 107.521 87.6709 107.6V109.27C91.9128 108.8 96.1344 108.162 100.326 107.358C102.809 106.881 104.815 104.704 105.461 101.821C109.329 84.5568 109.33 67.1987 105.461 49.9337C104.815 47.0502 102.809 44.873 100.326 44.3965Z",
    fill: "url(#paint8_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0005 101.823C35.6465 104.706 37.6527 106.883 40.1357 107.359C60.1578 111.202 80.3037 111.203 100.326 107.359C102.809 106.883 104.815 104.705 105.461 101.823C107.395 93.1904 108.362 84.5345 108.362 75.8789H32.0992C32.0995 84.5347 33.0665 93.1904 35.0005 101.823Z",
    fill: "url(#paint9_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5511 96.943C60.522 96.943 57.2439 93.6649 57.2439 89.6357V82.5882C57.2439 81.0605 56.5766 79.6358 55.4132 78.6793C51.9203 75.8077 50.0073 71.5682 50.1648 67.0479C50.2941 63.3305 51.8509 59.8448 54.548 57.2332C57.2437 54.6231 60.7768 53.178 64.4964 53.1641H64.5511C72.4888 53.1641 78.9465 59.6216 78.9465 67.5592C78.9465 71.8791 77.0306 75.9319 73.6902 78.6787C72.5261 79.6358 71.8584 81.0607 71.8584 82.5884V89.6359C71.8584 93.6649 68.5803 96.943 64.5511 96.943Z",
    fill: "url(#paint10_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8428 67.5575C75.8428 61.3068 70.7639 56.2423 64.5079 56.2657C58.4845 56.2883 53.4761 61.1345 53.2664 67.1542C53.1384 70.8313 54.7699 74.131 57.3841 76.2801C59.2679 77.8287 60.3475 80.1479 60.3475 82.5864V89.6342C60.3475 91.9558 62.2295 93.8378 64.5511 93.8378C66.8727 93.8378 68.7547 91.9558 68.7547 89.6342V82.7368L68.325 82.5864C68.325 80.1475 69.1904 77.6134 71.0744 76.0646C73.1739 74.3386 75.7131 69.2749 75.7131 69.2749C75.7919 68.714 75.8428 68.1414 75.8428 67.5575Z",
    fill: "url(#paint11_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8428 67.5575C75.8428 61.3068 70.7639 56.2423 64.5079 56.2657C58.4845 56.2883 53.4761 61.1345 53.2664 67.1542C53.1384 70.8313 54.7699 74.131 57.3841 76.2801C59.2679 77.8287 60.3475 80.1479 60.3475 82.5864V89.6342C60.3475 91.9558 62.2295 93.8378 64.5511 93.8378C66.8727 93.8378 68.7547 91.9558 68.7547 89.6342V82.7368L68.325 82.5864C68.325 80.1475 69.1904 77.6134 71.0744 76.0646C73.1739 74.3386 75.7131 69.2749 75.7131 69.2749C75.7919 68.714 75.8428 68.1414 75.8428 67.5575Z",
    fill: "url(#paint12_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8428 67.5575C75.8428 61.3068 70.7639 56.2423 64.5079 56.2657C58.4845 56.2883 53.4761 61.1345 53.2664 67.1542C53.1384 70.8313 54.7699 74.131 57.3841 76.2801C59.2679 77.8287 60.3475 80.1479 60.3475 82.5864V89.6342C60.3475 91.9558 62.2295 93.8378 64.5511 93.8378C66.8727 93.8378 68.7547 91.9558 68.7547 89.6342V82.7368L68.325 82.5864C68.325 80.1475 69.1904 77.6134 71.0744 76.0646C73.1739 74.3386 75.7131 69.2749 75.7131 69.2749C75.7919 68.714 75.8428 68.1414 75.8428 67.5575Z",
    fill: "url(#paint13_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2888 81.6172C60.3268 81.9375 60.3475 82.2613 60.3475 82.5874V89.6352C60.3475 91.9568 62.2295 93.8388 64.5511 93.8388C66.8727 93.8388 68.7547 91.9568 68.7547 89.6352V82.7378L68.3251 82.5874C68.3251 82.2647 68.3412 81.9407 68.3719 81.6172H60.2888Z",
    fill: "url(#paint14_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2888 81.6172C60.3268 81.9375 60.3475 82.2613 60.3475 82.5874V89.6352C60.3475 91.9568 62.2295 93.8388 64.5511 93.8388C66.8727 93.8388 68.7547 91.9568 68.7547 89.6352V82.7378L68.3251 82.5874C68.3251 82.2647 68.3412 81.9407 68.3719 81.6172H60.2888Z",
    fill: "url(#paint15_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6604 79.6701C11.1102 79.6701 9.04345 77.6033 9.04345 75.0553C9.04345 72.5051 11.1102 70.4405 13.6604 70.4405C16.2085 70.4405 18.2753 72.5051 18.2753 75.0553C18.2753 77.6033 16.2085 79.6701 13.6604 79.6701ZM46.1994 69.2773C42.734 69.2773 39.4855 67.5607 37.5541 64.6818C34.2197 59.7124 28.5629 56.4361 22.1369 56.4103C12.0435 56.3716 3.66032 64.5142 3.42399 74.6054C3.17692 85.107 11.616 93.6964 22.0638 93.6964C27.942 93.6964 33.1841 90.9765 36.6002 86.7247C38.6068 84.2304 41.6039 82.7394 44.805 82.7394H68.7537V82.589C68.7537 80.1505 69.8343 77.8302 71.7185 76.2812C73.8176 74.556 75.2849 72.0853 75.7125 69.2773H46.1994Z",
    fill: "url(#paint16_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9151 83.367C26.351 83.367 25.0833 82.0992 25.0833 80.5352V69.574C25.0833 68.01 26.351 66.7422 27.9151 66.7422C29.4792 66.7422 30.747 68.01 30.747 69.574V80.5352C30.7472 82.0992 29.4792 83.367 27.9151 83.367Z",
    fill: "url(#paint17_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1327 73.9336C18.2225 74.293 18.2753 74.6671 18.2753 75.0542C18.2753 77.6023 16.2085 79.6691 13.6605 79.6691C11.1103 79.6691 9.04347 77.6023 9.04347 75.0542C9.04347 74.6668 9.09633 74.2928 9.18613 73.9336H3.45689C3.44357 74.1566 3.42939 74.3794 3.42424 74.6045C3.17717 85.1061 11.6162 93.6956 22.0641 93.6956C27.9422 93.6956 33.1844 90.9756 36.6004 86.7239C38.6071 84.2295 41.6041 82.7385 44.8053 82.7385H68.7539V82.5881C68.7539 80.1497 69.8346 77.8293 71.7188 76.2803C72.5418 75.6029 73.2652 74.8129 73.8679 73.9336H18.1327Z",
    fill: "url(#paint18_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6605 68.4922C10.0339 68.4922 7.09485 71.4312 7.09485 75.0578C7.09485 78.6822 10.0339 81.6213 13.6605 81.6213C17.2849 81.6213 20.224 78.6822 20.224 75.0578C20.224 71.4312 17.2849 68.4922 13.6605 68.4922ZM13.6605 78.6844C11.656 78.6844 10.0339 77.0602 10.0339 75.0578C10.0339 73.0555 11.656 71.4312 13.6605 71.4312C15.6628 71.4312 17.287 73.0555 17.287 75.0578C17.287 77.0602 15.6628 78.6844 13.6605 78.6844Z",
    fill: "url(#paint19_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2949 71.9923C45.0377 71.9896 44.7826 72.0379 44.5442 72.1344C44.3059 72.231 44.089 72.3738 43.9062 72.5547C43.7234 72.7356 43.5783 72.9509 43.4793 73.1883C43.3802 73.4256 43.3292 73.6802 43.3292 73.9374C43.3292 74.1945 43.3802 74.4492 43.4793 74.6865C43.5783 74.9238 43.7234 75.1392 43.9062 75.3201C44.089 75.5009 44.3059 75.6438 44.5442 75.7403C44.7826 75.8369 45.0377 75.8852 45.2949 75.8825H72.1783C73.3638 74.7965 74.3042 73.4703 74.9369 71.9923H45.2949Z",
    fill: "url(#paint20_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5518 76.8752C51.1816 76.8752 50.8266 77.0223 50.5648 77.284C50.3031 77.5458 50.156 77.9009 50.156 78.2711C50.156 78.6413 50.3031 78.9963 50.5648 79.2581C50.8266 79.5198 51.1816 79.6669 51.5518 79.6669H69.2919C69.6867 78.6242 70.2918 77.6738 71.0695 76.875H51.5518V76.8752Z",
    fill: "url(#paint21_linear_703_257516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2594 82.7394H68.7537V82.5891C68.7537 80.1506 69.8344 77.8303 71.7186 76.2812C73.8176 74.556 75.285 72.0854 75.7125 69.2773H53.2594V82.7394Z",
    fill: "url(#paint22_linear_703_257516)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_703_257516",
    x1: 53.2849,
    y1: 5.64895,
    x2: 63.6707,
    y2: 23.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_703_257516",
    x1: 82.0619,
    y1: 17.2866,
    x2: 96.0431,
    y2: 17.2866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_703_257516",
    x1: 49.0152,
    y1: 37.9587,
    x2: 49.0152,
    y2: 51.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_703_257516",
    x1: 91.4466,
    y1: 29.297,
    x2: 91.4466,
    y2: 34.4606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BACDF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_703_257516",
    x1: 54.6835,
    y1: 49.999,
    x2: 85.708,
    y2: 101.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_703_257516",
    x1: 54.6017,
    y1: 94.3072,
    x2: 42.9616,
    y2: 80.2169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_703_257516",
    x1: 49.9479,
    y1: 87.6118,
    x2: 49.9479,
    y2: 82.3557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_703_257516",
    x1: 32.0404,
    y1: 28.8729,
    x2: 127.487,
    y2: 119.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_703_257516",
    x1: 98.2012,
    y1: 75.8769,
    x2: 106.96,
    y2: 75.8769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_703_257516",
    x1: 70.2308,
    y1: 90.6254,
    x2: 70.2308,
    y2: 110.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_703_257516",
    x1: 60.5258,
    y1: 72.1223,
    x2: 46.219,
    y2: 63.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_703_257516",
    x1: 57.3833,
    y1: 75.0519,
    x2: 71.1827,
    y2: 75.0519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_703_257516",
    x1: 60.9881,
    y1: 75.0519,
    x2: 52.4537,
    y2: 75.0519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_703_257516",
    x1: 63.0919,
    y1: 69.5087,
    x2: 56.7359,
    y2: 59.2473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_703_257516",
    x1: 64.1279,
    y1: 87.728,
    x2: 60.2959,
    y2: 87.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_703_257516",
    x1: 64.5219,
    y1: 88.5031,
    x2: 64.5219,
    y2: 82.5823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_703_257516",
    x1: 21.4655,
    y1: 57.9264,
    x2: 50.434,
    y2: 86.8949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_703_257516",
    x1: 30.597,
    y1: 75.0547,
    x2: 25.0495,
    y2: 75.0547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_703_257516",
    x1: 39.5644,
    y1: 79.7135,
    x2: 42.1169,
    y2: 91.3533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_703_257516",
    x1: 17.7116,
    y1: 79.1087,
    x2: 9.32364,
    y2: 70.7208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_703_257516",
    x1: 59.1433,
    y1: 75.6681,
    x2: 59.1433,
    y2: 72.0711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_703_257516",
    x1: 60.6127,
    y1: 79.6441,
    x2: 60.6127,
    y2: 77.2871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_703_257516",
    x1: 62.4053,
    y1: 74.7743,
    x2: 71.1862,
    y2: 79.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#DD8654",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#E28448",
    stopOpacity: 0.429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#EA8034",
    stopOpacity: 0.642
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#F47B18",
    stopOpacity: 0.854
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_703_257516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "translate(0.890625 0.242188)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d72851c7e2947649bfc3712aa4ead897.svg";
export { ForwardRef as ReactComponent };